/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState, useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "566")


// 接口文档



export interface IAPI77946ReqAppResourcePermissionObj {

  /** 部门ids ,String */
  deptIds?: string[];

  /** 用户ids ,String */
  userIds?: string[];

  /** 外部平台 ,String */
  platformCodeList?: string[];

  /** 权限类型 */
  permissionType?: string;

};





export interface API77946Req {

  /** 应用编码 */
  appCode?: string;
  /** 应用名称 */
  appName: string;
  /** 应用描述 */
  appDesc?: string;
  /** 应用资源配置 ,AppResourcePermissionReq */
  appResourcePermission?: IAPI77946ReqAppResourcePermissionObj;
};



export type API77946Res = {};


// 接口函数 77946 保存应用

export interface IUsePostAPI77946Return {
  /** 保存应用: 接口请求状态 */
  isAPI77946Loading: boolean;
  /** 保存应用: 接口请求返回数据 */
  dataAPI77946: API77946Res;
  /**  保存应用: 接口数据请求方法 */
  fetchAPI77946Data: (inputs: API77946Req, config?: YWRequestConfig) => Promise<API77946Res>;
  /** 保存应用: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI77946 = (): IUsePostAPI77946Return => {
  let isMount = true;
  const [isAPI77946Loading, setIsAPI77946Loading] = useState(false);
  const [dataAPI77946, setDataAPI77946] = useState<API77946Res>({} as API77946Res);
  const requestUrl = `${basePath}/yoaichat-admin/app/save`;

  const fetchAPI77946Data = async (inputs: API77946Req, config?: YWRequestConfig): Promise<API77946Res> => {


    const params = (reduceParams(inputs as unknown as R.Dictionary<API77946Req>) || {}) as API77946Req;


    if (isMount) {
      setIsAPI77946Loading(true);
    }

    try {



      const res: any = await Request.post<API77946Res>(`${basePath}/yoaichat-admin/app/save`, params, {
        loginHost: loginPath,
        ...config
      });


      if (isMount) {
        setDataAPI77946(res || {} as API77946Res);
        setIsAPI77946Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if (isMount) {
        setIsAPI77946Loading(false);
      }
      return false as unknown as API77946Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI77946Loading,
    dataAPI77946,
    fetchAPI77946Data,
    requestUrl,
  }
}

